import React, { useState } from 'react';
import { callDialerService, InitiateCallData } from '../../services/callDialerService';
import { FiPhone } from 'react-icons/fi';
import Icon from '../common/Icon';
import CallCompletionModal from './CallCompletionModal';

interface ClickToCallButtonProps {
  entityType: 'lead' | 'customer' | 'tender';
  entityId: number;
  entityName: string;
  phoneNumber: string;
  className?: string;
}

const ClickToCallButton: React.FC<ClickToCallButtonProps> = ({
  entityType,
  entityId,
  entityName,
  phoneNumber,
  className = ''
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const [callLogId, setCallLogId] = useState<number | null>(null);

  const handleCall = async () => {
    if (!phoneNumber) {
      setError('Phone number is required');
      return;
    }

    try {
      setLoading(true);
      setError('');

      // Initiate call in backend
      const result = await callDialerService.initiate({
        entity_type: entityType,
        entity_id: entityId,
        phone_number: phoneNumber,
        initiated_from: 'web_click'
      });

      setCallLogId(result.call_log_id);

      // Open phone dialer using tel: protocol
      window.location.href = `tel:${phoneNumber}`;

      // Show completion modal after a short delay
      setTimeout(() => {
        setShowCompletionModal(true);
      }, 1000);

    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to initiate call');
    } finally {
      setLoading(false);
    }
  };

  const handleComplete = async () => {
    setShowCompletionModal(false);
    setCallLogId(null);
  };

  return (
    <>
      <button
        onClick={handleCall}
        disabled={loading || !phoneNumber}
        className={`flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium ${className}`}
        title={`Call ${phoneNumber}`}
      >
        <Icon component={FiPhone} className="w-4 h-4" />
        <span className="hidden sm:inline">Call</span>
      </button>

      {error && (
        <div className="mt-2 text-xs text-red-600">{error}</div>
      )}

      {showCompletionModal && callLogId && (
        <CallCompletionModal
          callLogId={callLogId}
          entityType={entityType}
          entityId={entityId}
          entityName={entityName}
          phoneNumber={phoneNumber}
          onComplete={handleComplete}
        />
      )}
    </>
  );
};

export default ClickToCallButton;




